export default __webpack_public_path__ + "static/media/char_body_prem_010.af88c7de.png";